// src/Layout/Layout.jsx
import { Outlet } from "react-router-dom";
import { useState } from "react";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import styles from "./Layout.module.css";

const Layout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  return (
    <div className={styles.app}>
      <Sidebar 
        isCollapsed={isSidebarCollapsed}
        isMobileOpen={isMobileSidebarOpen}
        onToggle={toggleSidebar}
        onClose={closeMobileSidebar}
      />
      
      {isMobileSidebarOpen && (
        <div 
          className={styles.overlay} 
          onClick={closeMobileSidebar}
        />
      )}

      <div className={`${styles.main} ${isSidebarCollapsed ? styles.mainExpanded : ''}`}>
        <Header 
          onMenuClick={toggleMobileSidebar}
          isSidebarCollapsed={isSidebarCollapsed}
        />
        <div className={styles.content}>
          {children || <Outlet />}
        </div>
      </div>
    </div>
  );
};

export default Layout;